import React from 'react'

const CheckMarkIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
       style={props.style} className='icon--checkmark'
       viewBox='0 0 32 32'
  >
    <path
      d='M28.1,5.4c-0.7,0-1.4,0.3-1.9,0.8l-14,14L5.5,15c-1.2-0.9-2.9-0.7-3.9,0.5c-0.9,1.2-0.7,2.9,0.5,3.9l8.7,6.7c1.1,0.8,2.6,0.7,3.6-0.2l15.7-15.7c1.1-1.1,1.1-2.8,0.1-3.9C29.6,5.6,28.9,5.3,28.1,5.4L28.1,5.4z'
    />
  </svg>
)

export default CheckMarkIcon
